import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class MachineService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Machine
  getMachines(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/machine/GetListMachines/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getMachineById(id: number) {
    return this._http.get(this.myAppUrl + 'api/machine/GetMachineById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getMachinesByDeviceId(id: number) {
    return this._http.get(this.myAppUrl + 'api/machine/GetListMachinesByDeviceId/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getLastReturnMachineByDeviceId(id: number) {
    return this._http.get(this.myAppUrl + 'api/machine/GetLastReturnMachineByDeviceId/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addMachine(data) {
    return this._http.post(this.myAppUrl + 'api/machine/AddMachine', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateMachine(data) {
    return this._http.put(this.myAppUrl + 'api/machine/UpdateMachine', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteMachine(data) {
    return this._http.delete(this.myAppUrl + "api/machine/DeleteMachine/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/machine-service.ts